function determineButtonText(windowWidth, mobileText, desktopText) {
  var isMobile = windowWidth < 540;
  var hideMobileText = (mobileText === null || mobileText === void 0 ? void 0 : mobileText.toLowerCase()) === 'none';
  var buttonText = desktopText; // Default to desktopText

  if (isMobile) {
    if (hideMobileText) {
      buttonText = ''; // Hide text for mobile
    } else if (mobileText) {
      buttonText = mobileText; // Use mobileText if available
    }
  }
  return buttonText;
}

export { determineButtonText as default };
//# sourceMappingURL=determineButtonText.js.map
